import { CheckCircleOutlineRounded, ChevronRight, ExpandMore, RadioButtonUncheckedOutlined } from '@mui/icons-material'
import { Box, Checkbox, FormControl, FormControlLabel } from '@mui/material'
import { TreeItem, TreeView } from '@mui/x-tree-view'
import { useTranslation } from 'react-i18next'
import SubtitleGrey from '../../../../../../shared/styles/SubtitleGrey'

interface VerificationUserInfoProps {
  verification: number
  handleCheckChange: any
}

export function VerificationUserInfo({ verification, handleCheckChange }: VerificationUserInfoProps) {
  const { t } = useTranslation(['global'])

  return (
    <Box pb={1}>
      <FormControl fullWidth style={{ marginBottom: 0 }}>
        <TreeView defaultCollapseIcon={<ExpandMore />} defaultExpandIcon={<ChevronRight />} multiSelect>
          <TreeItem
            nodeId="1"
            label={
              <SubtitleGrey variant="body1" style={{ height: 40, display: 'flex', alignItems: 'center' }}>
                {t('admin.people.verification')}
              </SubtitleGrey>
            }
          >
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  color="default"
                  icon={<RadioButtonUncheckedOutlined fontSize="small" />}
                  checkedIcon={<CheckCircleOutlineRounded fontSize="small" />}
                  checked={verification === 1}
                  onChange={handleCheckChange}
                  value="1"
                />
              }
              label={t('admin.people.verified')}
              style={{ width: '100%' }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  color="default"
                  icon={<RadioButtonUncheckedOutlined fontSize="small" />}
                  checkedIcon={<CheckCircleOutlineRounded fontSize="small" />}
                  checked={verification === 0}
                  onChange={handleCheckChange}
                  value="0"
                />
              }
              label={t('admin.people.pending')}
              style={{ width: '100%' }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  color="default"
                  icon={<RadioButtonUncheckedOutlined fontSize="small" />}
                  checkedIcon={<CheckCircleOutlineRounded fontSize="small" />}
                  checked={verification === 3}
                  onChange={handleCheckChange}
                  value="3"
                />
              }
              label={t('deny')}
              style={{ width: '100%' }}
            />
          </TreeItem>
        </TreeView>
      </FormControl>
    </Box>
  )
}
